import React from 'react'
import {IconButton, Popover, Typography, Button} from '@material-ui/core';
import '../App.css';
import { FiHelpCircle } from "react-icons/fi";
import { Transition } from 'react-transition-group';
import { useStyles } from '../Components/useStyles';
 
export default function NewExistingStudentPage({isNewStudent, showNESPage, schoolYear, prevSchoolYear}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    function openHelp(event) {
        setAnchorEl(event.currentTarget);
    }
    function closeHelp() {
        setAnchorEl(null);
    }
    
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const duration = 700;

    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };
    return (
        <>
            <Transition in={showNESPage} timeout={duration} appear>
            {state => (
            <div style={{
                ...defaultStyle,
                ...transitionStyles[state]
            }}>
                <h1 className='Title2-settings'>Is the student new to SD38 for the {schoolYear} school year?</h1>
                <p className='addSpaceTop'> </p>
                <p className='details'>Click <span style={{color: "#6495ED"}}>Yes</span> if the student does not currently attend school in SD38.<br/><br/>
                   Click <span style={{color: "red"}}>No</span> if the student is currently attending a SD38 for the {prevSchoolYear} school.</p>
                <p className='addSpaceBottom'> </p>
                <Button variant="outlined"  color="primary" className={classes.yesbutton} onClick={event=>isNewStudent(true)}>Yes</Button>           
                <Button variant="outlined"  color="primary" className={classes.nobutton} onClick={event=>isNewStudent(false)}>No</Button>
            </div>)}
            </Transition> 
        </>
    );
}